import Page from '../components/Page';
import image from '../static/images/terms.jpg';


const TermsAndConditions = (props) => {

  document.title = 'Terms - De School Amsterdam';
  const headerTitle = 'Terms';
  const description = 'terms & conditions terms & conditions terms & conditions';



  const content = <div className='content'>
  De School | Dr. Jan van Breemenstraat 1 1056 AB Amsterdam<br/><br/>

T +31 (0)20 737 31 97 | | info@deschoolamsterdam.nl<br/><br/>

KVK: 34202405 | BTW: NL8129.13.280.B01 |<br/><br/>
TRIODOS BANK: NL28TRIO0786830263<br/><br/>

Artikel 1 - Definities<br/><br/>

POST CS B.V.: de besloten vennootschap met beperkte aansprakelijkheid POST CS B.V.,
handelend onder de naam De School, gevestigd en kantoorhoudende in (1056 AB) Amsterdam
aan de Dr. Jan van Breemenstraat 1, is een tijdelijk restaurant, club en horecabedrijf
in de ruimste zin van het woord. Zij maakt haar bedrijf van het verlenen van horecadiensten,
het ter beschikking stellen van (zaal)ruimte en/of terreinen, het organiseren van evenementen,
alles met de daarbij behorende werkzaamheden en diensten.<br/><br/>

De School, een tijdelijk en multifunctioneel horecabedrijf gelegen aan de Dr. Jan van Breemenstraat 1.<br/><br/>

Bezoeker: iedere natuurlijke persoon, die niet handelt in de uitoefening van een beroep of bedrijf en
die direct of indirect een overeenkomst sluit met De School in het kader van een regulier bezoek aan De School
of het bijwonen van een Evenement alsmede een ieder die zich in of rondom De School of de Externe Evenementslocatie
begeeft.<br/><br/>

Evenement: een gebeurtenis, waaronder begrepen een (muziek)-uitvoering en/of andere manifestatie,
een concert, dance-event, business-event en/of een openbare of besloten gebeurtenis waaraan één of
meerdere personen deelnemen, georganiseerd en/of gefaciliteerd door Post CS BV in De School.<br/><br/>

Externe Evenementslocatie: locatie waar een Evenement plaatsvindt, zijnde een andere locatie dan De School,
welke is ingezet ten behoeve van het Evenement door Post CS BV.<br/><br/>

Algemene Bezoekersvoorwaarden: de onderhavige Algemene Bezoekersvoorwaarden die op (rechts)verhouding tussen
de Bezoeker en Post CS BV van toepassing zijn.<br/><br/>

Overeenkomst:> iedere overeenkomst gesloten tussen de Bezoeker en Post CS BV.
in het kader van een regulier bezoek aan De School en/of het bijwonen van een Evenement.<br/><br/>

(Voor)verkoopadres: een ten behoeve van de verkoop van toegangsbewijzen voor
Evenementen door De School ingeschakelde (voor)verkooporganisatie.<br/><br/>

Toegangsbewijs: een bewijs, door of vanwege Post CS BV verstrekt,
waaruit de bevoegdheid van de Bezoeker blijkt zich in De School of op de Externe Evenementslocatie te mogen bevinden.<br/><br/>

Toegangsprijs: de prijs voor een Toegangsbewijs, exclusief eventuele extra service- en/of administratiekosten.<br/><br/>

Website: de website van Post CS BV / De School<br/><br/>

Artikel 2 – Toepasselijkheid<br/><br/>

Deze Algemene Bezoekersvoorwaarden zijn van toepassing op iedere Overeenkomst die tot stand komt tussen
Post CS BV en de Bezoeker ongeacht de wijze waarop deze Overeenkomst tot stand komt, alsook op ieder bezoek van de
Bezoeker aan De School en/of de Externe Evenementslocatie.<br/><br/>

Post CS BV heeft het recht deze Algemene Bezoekersvoorwaarden te allen tijde geheel of gedeeltelijk te wijzigen.
Post CS BV zal de Bezoeker tijdig van de wijzigingen in de Algemene Bezoekersvoorwaarden in kennis stellen door
dit op haar website te melden. Indien de Bezoeker van mening is dat de wijzigingen in strijd met de redelijkheid
en billijkheid zijn, dan dient de Bezoeker Post CS BV hiervan binnen 10 werkdagen na de in kennis stelling te berichten,
bij gebreke waarvan de Bezoeker zich met de wijzigingen akkoord verklaart.<br/><br/>

De nietigheid van enige bepaling van deze Algemene Bezoekersvoorwaarden tast de geldigheid
van de overige bepalingen van deze Algemene Bezoekersvoorwaarden niet aan.<br/><br/>

ARTIKEL 3 – Aanbiedingen en totstandkoming Overeenkomst<br/><br/>

Informatie, aanbiedingen, mededelingen en prijsopgaven met betrekking tot Evenementen en/of (de verkoop van)
Toegangsbewijzen worden zo nauwkeurig mogelijk door Post CS BV en/of een derde mondeling, telefonisch of via e-mail
(weer)gegeven of verstrekt. Post CS BV aanvaardt geen aansprakelijkheid voor eventuele onjuistheden of onvolledigheden
in de hiervoor bedoelde door Post CS BV en/of derden gedane mededelingen.<br/><br/>

Een Overeenkomst komt tot stand op het moment dat de Bezoeker een Toegangsbewijs bij De School,
althans bij een door Post CS BV ingeschakeld (Voor)verkoopadres, heeft betaald en geleverd heeft gekregen.<br/><br/>

ARTIKEL 4 – Toegang en Toegangsbewijs<br/><br/>

Een Toegangsbewijs wordt eenmalig aan Bezoeker verstrekt en geeft aan één Bezoeker toegang tot De School
en/of een Externe Evenementslocatie.<br/><br/>

Een Toegangsbewijs kan bestaan uit een door of vanwege De School verstrekt document of een door of vanwege
De School verstrekte barcode. De barcode is een unieke code.<br/><br/>

Wanneer de Bezoeker bij de aanschaf van een Toegangsbewijs aanspraak maakt op korting, dient de Bezoeker het
document dat recht geeft op korting te tonen.<br/><br/>

De Bezoeker dient bij het betreden van De School en/of de Externe Evenementslocatie en gedurende de
periode dat de Bezoeker in De School en/of op de Externe Evenementslocatie aanwezig is, te beschikken
over een geldig Legitimatiebewijs en een geldig Toegangsbewijs en deze op eerste verzoek van medewerkers
van De School, beveiligingspersoneel, politie en/of ander bevoegd gezag te tonen.<br/><br/>

Toegangsbewijzen zijn en blijven eigendom van De School. Een Toegangsbewijs verschaft slechts de
houder van het Toegangsbewijs toegang tot De School en/of de Externe Evenementslocatie.<br/><br/>

De Bezoeker is niet gerechtigd tot restitutie van de Toegangsprijs of enige andere vergoeding
in geval van verlies, diefstal beschadiging of misbruik van het Toegangsbewijs, alsmede in het
geval dat de Bezoeker om welke reden dan ook geen gebruik maakt van het Toegangsbewijs.<br/><br/>

Een eenmaal verkregen Toegangsbewijs kan niet worden teruggeven of geruild.<br/><br/>

De Bezoeker kan de toegang tot De School of de Externe Evenementslocatie worden ontzegd,
wanneer zou blijken dat het Toegangsbewijs niet is verkregen van Post CS BV of van een door Post CS BV
ingeschakeld (Voor)verkoopadres.<br/><br/>

Het is verboden het Toegangsbewijs op welke wijze dan ook aan derden door te verkopen,
te koop aan te bieden of anderszins voor commerciële doeleinden te exploiteren, met uitzondering
van een door Post CS aangewezen ticketing partner.<br/><br/>

ARTIKEL 5 - Verblijf in De School of op de Externe Evenementslocatie<br/><br/>

Bezoekers van De School en/of de Externe Evenementslocatie dienen tenminste 21 jaar oud te zijn.
Medewerkers van De School en/of beveiligingspersoneel kunnen te allen tijde de Bezoeker verzoeken zich
te identificeren met een geldig Legitimatiebewijs. Indien en zodra blijkt dat de Bezoeker de leeftijd van
21 jaar nog niet heeft bereikt, kan de Bezoeker de toegang tot De School en/of de Externe Evenementslocatie
worden ontzegd.<br/><br/>

Bezoekers zijn gehouden zich in overeenstemming met de in het maatschappelijk verkeer geldende
regels van goed fatsoen en goede zeden te gedragen. Indien de Bezoeker zich naar het oordeel van
medewerkers van De School en/of beveiligingspersoneel niet op een dergelijke wijze gedraagt, kan
de Bezoeker hier door medewerkers van De School en/of beveiligingspersoneel op worden aangesproken.
Bij herhaling of voortduren van gedragingen van de Bezoeker die niet in overeenstemming met de in
het maatschappelijk verkeer geldende regels van goed fatsoen en goede zeden zijn, kan de Bezoeker de
toegang tot het Evenement worden ontzegd en indien noodzakelijk worden overgedragen aan de politie,
zonder het recht op vergoeding van de Toegangsprijs van het Toegangsbewijs en eventuele in rekening
gebrachte service- en/of administratiekosten en/of anderszins ontstane kosten.<br/><br/>

Vastleggen van het bezoek aan De School of het Evenement door de Bezoeker in welke vorm dan ook, op welke
(digitale) drager dan ook, waaronder mede begrepen het fotograferen, filmen, dan wel iedere andere wijze
van het maken van geluids-, en/of beeldopnamen van het Evenement, is niet toegestaan.<br/><br/>

De School behoudt zich het recht voor om gedurende een reguliere clubavond of gedurende een Evenement geluids-,
en/of beeld  opnamen te maken. De Bezoeker die een reguliere clubavond of een Evenement bezoekt:<br/>

Stemt in met opname en/of gebruik van zijn/haar naam, stem, portret en /of afbeelding door middel van al dan niet
live uitgezonden en opgenomen audio en video display, uitzending of andere vorm van distributie waaronder foto’s
of’ andere huidige en/of toekomstige media technologieën:<br/>
Geeft onvoorwaardelijk toestemming tot het gebruik zoals bedoeld in sub a) om niet,
voor onbepaalde tijd en wereldwijd:<br/>
Stelt noch Post CS BV noch partijen die met toestemming van Post CS BV gebruik maken van beeld- en/of geluidsmateriaal
voor al dan niet commerciële doeleinden, aansprakelijk voor het gebruik van dit beeld- en /of geluidsmateriaal;
Doet afstand van zijn/haar portretrecht, voor zover het gaat om beelden in en rond De School en/of de Externe
Evenementslocatie waarbij hij/zij herkenbaar in beeld komt:<br/>
Erkent dat een videobewakingssysteem operationeel is en gaat ermee akkoord dat door of namens Post CS BV in
het kader van openbare orde en veiligheid video opnamen van de Bezoeker gemaakt kunnen worden.<br/><br/>

Het is de Bezoeker niet toegestaan in De School of op de Evenementenlocatie promotiemateriaal,
waaronder mede begrepen samples, reclame en/of foldermateriaal uit te delen of te doen uitdelen voor
zover de wet dit toelaat, tenzij de Bezoeker hiertoe de uitdrukkelijke schriftelijke toestemming van
Post CS BV heeft verkregen.<br/><br/>

In De School is het sinds 1 januari 2022 strikt verboden binnen te roken.<br/><br/>

Post CS BV zal al hetgeen in alle redelijkheid binnen haar mogelijkheden ligt, ondernemen om de veiligheid van de
Bezoeker in De School of op de Externe Evenementslocatie zo veel mogelijk te waarborgen. In het kader van de
veiligheid in De School of op de Externe Evenementslocatie is de Bezoeker dan ook gehouden op eerste verzoek
van medewerkers van De School, beveiligingspersoneel, politie en/of ander bevoegd gezag:
zijn of haar medewerking te verlenen aan onderzoek aan kleding (fouilleren);<br/>
inzage te verschaffen in meegevoerde (hand)tas(sen); en/of
een detectiepoort te passeren;<br/>
zich te legitimeren.<br/><br/>

Het is de Bezoeker niet toegestaan zich (onnodig) op te houden voor nooduitgangen en plaatsen in De School
of op de Externe Evenementslocatie waar brandblussers hangen of andere brandwerende- en/of veiligheidsmaatregelen
zijn getroffen.<br/><br/>

Het is de Bezoeker uitdrukkelijk niet toegestaan glaswerk, plastic flessen, blik, vuurwerk, drugs,
(vuur)wapen en/of andere gevaarlijke voorwerpen en/of stoffen, etenswaren en/of (alcoholhoudende)
dranken en/of (huis)dieren mee te brengen naar, althans in bezit te hebben in De School of op de
Externe Evenementslocatie, op straffe van inbeslagname van deze zaken en/of overdracht aan de politie.<br/><br/>

Het is de Bezoeker niet toegestaan (de inventaris van) De School of de Externe Evenementslocatie op welke wijze
dan ook aan te tasten en/of te beschadigen. Indien de Bezoeker op enigerlei wijze schade toebrengt aan
(de inventaris van) De School of de Externe Evenementslocatie is de Bezoeker gehouden deze schade te vergoeden.<br/><br/>

De Bezoeker is gehouden instructies, voorschriften en/of aanwijzingen van medewerkers van De School,
beveiligingspersoneel, de politie en/of ander bevoegd gezag op eerste verzoek op te volgen.<br/><br/>

Indien de Bezoeker weigert zich aan de in dit artikel genoemde (veiligheid)voorschriften te houden,
kan de Bezoeker de toegang tot De School en/of de Externe Evenementslocatie worden ontzegd, zonder
het recht op enige vergoeding van de Toegangsprijs van het Toegangsbewijs en eventuele in rekening
gebrachte service- en/of anderszins ontstane kosten.<br/><br/>

ARTIKEL 6 - Aansprakelijkheid<br/><br/>

Bezoekers houden zich geheel op eigen risico op in De School en/of op de Externe Evenementslocatie.<br/>

Post CS BV aanvaardt geen aansprakelijkheid voor enigerlei schade, uit welke hoofde dan ook, welke direct
of indirect het gevolg is van handelen of nalaten van Post CS BV, van personen in haar dienst, of van andere
personen die door of vanwege haar te werk zijn gesteld, of van derden, tijdens het Evenement of in verband
met het verblijf in De School en/of op de Externe Evenementslocatie, tenzij de schade het gevolg is van
opzet of grove schuld.<br/><br/>

Indien en voor zover Post CS BV op welke grond ook jegens de Bezoeker aansprakelijk mocht zijn voor
enige door de Bezoeker geleden schade, dan is deze aansprakelijkheid te allen tijde beperkt tot
het bedrag, dat ingevolge de wettelijke aansprakelijkheidsverzekering van Post CS BV zal worden uitgekeerd.<br/>

De School kan niet aansprakelijk worden gehouden voor verlies van kleding en/of andere eigendommen van de
Bezoeker. Indien een Bezoeker eigendommen van een andere Bezoeker vindt, dient hij of zij deze aan de
persoon werkzaam achter de bar of kassa van De School en/of de Externe Evenementslocatie af te geven.
Gevonden voorwerpen worden door Post CS BV twee weken in bewaring genomen, gedurende welke periode de
rechtmatige eigenaar de door hem of haar verloren eigendom(men) in De School en/of op de Externe
Evenementslocatie kunnen worden afgehaald.<br/><br/>

ARTIKEL 7 – Overmacht<br/><br/>

Post CS BV kan niet aansprakelijk worden gehouden voor schade van de Bezoeker welke is ontstaan
ten gevolge van overmacht. Onder overmacht wordt mede verstaan: stakingen, brand, extreme weersomstandigheden,
epidemieën en alle overige van de wil van Post CS BV onafhankelijke omstandigheden. In geval van overmacht
heeft Post CS BV het recht het Evenement te verschuiven naar een andere datum of het Evenement te annuleren.<br/><br/>

Indien een Evenement als gevolg van of in verband met overmacht door Post CS BV wordt verschoven naar een
andere datum blijft het Toegangsbewijs geldig voor de nieuwe datum waarop het Evenement zal plaatsvinden.
Mocht de Bezoeker het Evenement op de nieuwe datum niet kunnen of willen bezoeken dan is de Bezoeker gerechtigd
het Toegangsbewijs te retourneren aan Post CS BV of aan een door Post CS BV ingeschakeld (Voor)verkoopadres
tegen restitutie van de vergoeding welke vermeld staat op het Toegangsbewijs, ongeacht welke prijs de Bezoeker
voor het Toegangsbewijs heeft betaald. Service- en/of administratiekosten zullen niet worden vergoed.<br/><br/>

ARTIKEL 8 – Privacy en persoonsgegevens<br/><br/>

In De School hangen beveiligingscamera’s waarmee (beeld)opnamen worden gemaakt.
In het geval van calamiteiten kan Post CS BV deze (beeld)opnamen aan derden, waaronder mede
begrepen politie en justitie, afstaan.<br/><br/>

Zie voor verdere details over privacy de pagina privacy policy.<br/><br/>

ARTIKEL 9 – Klachten<br/><br/>

De School zal al hetgeen in alle redelijkheid binnen haar mogelijkheden ligt,
ondernemen om het verblijf van de Bezoeker gedurende in De School of op de Externe
Evenementslocatie zo prettig mogelijk te maken. De School tracht daarbij eventuele overlast of
ongemakken voor de Bezoeker tot een minimum te beperken alsmede de veiligheid van de Bezoeker
zoveel mogelijk te waarborgen. Mocht de Bezoeker onverhoopt klachten hebben ter zake de uitvoering
van de Overeenkomst en/of de dienstverlening van Post CS BV, dan kan de Bezoeker hiervan schriftelijk
melding maken door een e-mail te sturen naar tellus@deschoolamsterdam.nl. Klachten dienen uiterlijk binnen zeven
(7) dagen na de datum van het verblijf in De School of op de Evenementslocatie bij Post CS BV te worden gemeld.<br/><br/>

ARTIKEL 10 - Geschillen<br/><br/>

Op deze Algemene Bezoekersvoorwaarden en alle Overeenkomsten waarop deze Algemene Bezoekersvoorwaarden van toepassing zijn,
is uitsluitend Nederlands recht van toepassing.<br/><br/>
Alle geschillen, van welke aard dan ook, die naar aanleiding van of in verband met de Overeenkomst of naar
aanleiding van of in verband met nadere overeenkomsten ter uitvoering daarvan, tussen een Bezoeker en De School
ontstaan, zullen uitsluitend worden voorgelegd aan de bevoegde rechter te Amsterdam.<br/><br/>
Indien de Algemene Bezoekersvoorwaarden ook in een andere dan de Nederlandse taal worden gebruikt,
is de Nederlandse tekst doorslaggevend in geval van geschillen over de uitleg ervan.<br/><br/>

Aldus opgemaakt te Amsterdam, 29 juli 2022


 </div>

  const contentEN =  <div className='content'>We do not have an English version of our Terms & Conditions.<br/>
  Any clarity needed on this in English please contact info@deschoolamsterdam.nl</div>

  return <Page
          headerTitle={headerTitle}
          description={description}
          content={props.langNL ? content : contentEN}
          image={image}
          langNL={props.langNL}
          changeLang={props.changeLang}/>


};

export default TermsAndConditions;
